import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=6f8e7952&scoped=true"
import script from "./bannerForm.vue?vue&type=script&lang=ts"
export * from "./bannerForm.vue?vue&type=script&lang=ts"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=6f8e7952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e7952",
  null
  
)

export default component.exports